import React, {Component} from 'react';
import styled from 'styled-components';
import {ButtonStyle, Title, Bold} from '../Styles';
import {CheckBox} from '../Shared/FormHelpers';

const MainContent = styled.div `
  padding: 0 0 0 25px;
  line-height: 18px;
  color: #8290a2;
  font-size: 14p;
  input[type=checkbox] {
    margin-right: 10px;
  }
`

const Section = styled.section`
  margin-bottom: 40px;
`

const Header = styled.div `
  width: 100%;
  float: left;
  padding: 20px 20px 10px;
  background-color: #f6f7f8;
  border-bottom: 1px solid #ccc;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
`

const HeaderTitle = styled.div`
  width: 100%;
  float: left;
  margin: 0 0 7px;
  font-family: 'Raleway';
  font-weight: 700;
  color: #39b54a;
  font-size: 24px;
  padding: 0;
`

export default class Help extends Component {

  constructor(props) {
    super(props)
    this.state = {
      advisor: props.advisor,
      reports: props.reports,
      announcments: props.announcments,
      updates: props.updates,
      offers: props.offers,
      ethnicity: props.ethnicity,
      gender: props.gender,
      veteran: props.veteran,
    }
  }

  handleChange = (e) => {
    let name = e.target.name;
    let value = (e.target.type === 'checkbox') ? e.target.checked : e.target.value;
    this.setState({[name]: value});
  }

  render() {
    const { user } = this.props;

    return (
      <div>
        <Header>
          <HeaderTitle>Help</HeaderTitle>
        </Header>
        <MainContent>
          <Section>
            <div>
              <p style={{padding: "100px 0px"}}>
                <Bold>This section coming soon...</Bold>
              </p>
            </div>
          </Section>
        </MainContent>
      </div>
    )
  }
}
